import { emptyValidationResponse } from '../urlValidationUtils'

const AirtableValidator = (url: string) => {
  let regexGroups

  // First attempt
  regexGroups = /(?:https:\/\/)?(?:www.)?airtable.com\/embed\/[\w\-_]+/.exec(url)
  if (regexGroups?.[0])
    return {
      validUrl: regexGroups[0],
      isEmbeddable: true,
    }

  // Second attempt
  regexGroups = /(?:https:\/\/)?(?:www.)?airtable.com\/([\w\-_]+)(?:\/embed)?/.exec(url)
  if (regexGroups?.[1])
    return {
      validUrl: `https://airtable.com/embed/${regexGroups[1]}`,
      isEmbeddable: true,
    }

  return emptyValidationResponse
}

export default AirtableValidator
